import { Route } from "./types";
import { AdminHomeRedirect, Home } from "../../../pages/home";
import { AuthPage } from "../../../pages/auth";
import { ROUTER_PATHS } from "../../../shared/constants/router-paths";
import { PermissionsManagement } from "../../../pages/admin";

export const routesConfig: Route[] = [
  {
    path: "/",
    private: true,
    children: [
      { index: true, element: <AdminHomeRedirect /> },
      {
        path: ROUTER_PATHS.PERMISSIONS,
        element: <PermissionsManagement />,
      },
      {
        path: ":section",
        element: <Home />,
      },
    ],
  },
  {
    path: "/auth",
    private: false,
    element: <AuthPage />,
  },
];
